import { i18nReady } from './i18n';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from '@robinpowered/ui-kit';
import App from './App';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { IframeRenderDataProvider } from '@/contexts';
import { initLogger, logger } from '@/utils/logger';
import { robinTheme } from './theme/robinTheme';
import '@robinpowered/ui-kit/fonts.css';
import '@/index.css';

initLogger(import.meta.env.VITE_SENTRY_DSN, import.meta.env.VITE_SENTRY_ENVIRONMENT);

void i18nReady
  .then(() => {
    createRoot(document.getElementById('root')!).render(
      <StrictMode>
        <ErrorBoundary>
          <IframeRenderDataProvider>
            <ConfigProvider theme={robinTheme}>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </ConfigProvider>
          </IframeRenderDataProvider>
        </ErrorBoundary>
      </StrictMode>
    );
  })
  .catch((err: unknown) => {
    logger.error(err, 'Failed to initialize i18n');
  });
